<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Filter organisations</ion-title>
        <ion-buttons *ngIf="online && !loading" slot="end">
            <ion-button (click)="clearFilters()">
                <fa-icon [icon]="['far', 'trash-alt']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
                <span>Clear</span>
            </ion-button>
            <ion-button (click)="filter()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid *ngIf="!loading" class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row *ngIf="categories && categories.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="category_select_options" (ionCancel)="clearCategory()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['category_id']">
                                <div slot="label">Category<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let category of categories" value="{{category.id}}">{{category.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="tags && tags.length != 0">
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="tag_select_options" (ionCancel)="clearTag()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['tag_id']">
                                <div slot="label">Tag<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option *ngFor="let tag of tags" value="{{tag.id}}">
                                    <span *ngIf="!tag.group">Ungrouped > </span>
                                    <span *ngIf="tag.group">{{tag.group.title}} > </span>{{tag.title}}
                                </ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" interface="alert" [interfaceOptions]="website_status_select_options" (ionCancel)="clearWebsiteStatus()" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['website_status']">
                                <div slot="label">Website status<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option value="published">Published</ion-select-option>
                                <ion-select-option value="unpublished">Unpublished</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasCreditLimit()" interface="alert" [interfaceOptions]="has_credit_limit_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_credit_limit']">
                                <div slot="label">Has credit limit<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                                <ion-select-option [value]="false">No</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasAmountOwing()" interface="alert" [interfaceOptions]="has_amount_owing_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_amount_owing']">
                                <div slot="label">Has amount owing<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                                <ion-select-option [value]="false">No</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Clear" okText="OK" (ionCancel)="clearHasExceededCreditLimit()" interface="alert" [interfaceOptions]="has_exceeded_credit_limit_select_options" labelPlacement="stacked" fill="outline" [(ngModel)]="filter_params['has_exceeded_credit_limit']">
                                <div slot="label">Has exceeded credit limit<ion-text class="optional">optional</ion-text></div>
                                <ion-select-option [value]="true">Yes</ion-select-option>
                                <ion-select-option [value]="false">No</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>